import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrSimpleMessageModal, {
  SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP,
} from 'client/components/SrSimpleMessageModal/SrSimpleMessageModal';

import {
  SR_BUTTON_THEME_ADOBE_GREEN,
  SR_BUTTON_THEME_ADOBE_GREY,
} from 'client/components/SrButton/SrButton';

const SrUtilitySetupTransferInternetFlowProviderNotAvailableModal = ({
  providerName,
  onSubmit,
  onBack,
}) => {
  return (
    <SrSimpleMessageModal
      iconUrl="/images/emoji-denied.png"
      theme={SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP}
      contentContainerClassName="utilityProviderContact"
      iconBgColor="#FFFBEB"
      maxWidth="320px"
      maxIconHeight="100px"
      maxIconWidth="100px"
      headline={
        <SrBox maxWidth="280px" margin="0 auto">
          <SrText fontSize="24px" weight="800" font="greycliff" display="block">
            Oops, {providerName || 'the selected internet provider'}&nbsp; is not wired at your new
            home.
          </SrText>
        </SrBox>
      }
      underline
      srMultiButtons={[
        {
          buttonText: 'See internet options',
          onButtonClick: onSubmit,
          buttonTheme: SR_BUTTON_THEME_ADOBE_GREEN,
        },
        {
          buttonText: 'Back',
          onButtonClick: onBack,
          buttonTheme: SR_BUTTON_THEME_ADOBE_GREY,
        },
      ]}
    />
  );
};

SrUtilitySetupTransferInternetFlowProviderNotAvailableModal.propTypes = {
  providerName: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

SrUtilitySetupTransferInternetFlowProviderNotAvailableModal.displayName =
  'SrUtilitySetupTransferInternetFlowProviderNotAvailableModal'; // eslint-disable-line max-len

export default SrUtilitySetupTransferInternetFlowProviderNotAvailableModal;
